import { render, staticRenderFns } from "./NewRealEstateBuildingComparativeCalculatedView.vue?vue&type=template&id=c8f04502&"
import script from "./NewRealEstateBuildingComparativeCalculatedView.vue?vue&type=script&lang=js&"
export * from "./NewRealEstateBuildingComparativeCalculatedView.vue?vue&type=script&lang=js&"
import style0 from "./NewRealEstateBuildingComparativeCalculatedView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports